import { render, staticRenderFns } from "./UserReminderButton.vue?vue&type=template&id=47019b09&scoped=true&"
import script from "./UserReminderButton.vue?vue&type=script&lang=js&"
export * from "./UserReminderButton.vue?vue&type=script&lang=js&"
import style0 from "./UserReminderButton.vue?vue&type=style&index=0&id=47019b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47019b09",
  null
  
)

export default component.exports